// extracted by mini-css-extract-plugin
export default {"container":"vpTUl7","post":"kulqsM","hashtags":"XwJvwJ","separator":"rkyuPR","content":"EigW40","commentExcerpt":"IAnpdE"};